import React, { useState } from 'react';
import AllFilterCategory from './AllFilterCategory/AllFilterCategory';
import { ReactComponent as Chevron } from '../../../../../assets/icons/chevron.svg';
import { ReactComponent as AmenitiesIcon } from '../../../../../assets/icons/redesign_amenities_icon.svg';
import data from './allFilter.json';
import styles from './AllFilter.module.scss';
import { useResultListContext } from 'common/contexts/ResultListContext';

interface Props {
  fetchData: Function,
}

type CategoryFilter = {
  [key: number]: string;
};

type AllFilters = {
  [category: string]: CategoryFilter;
};

const typedData: AllFilters = data;

const AllFilter: React.FC<Props> = ({
  fetchData,
}) => {
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [checkedCount, setCheckedCount] = React.useState(0);

  const {
    activeFilters,
    setActiveFilters,
    currentDuration,
    currentLocation,
    currentResources,
    setCurrentAmenities,
    setCurrentPage,
    budgetValues,
    sortBy,
  } = useResultListContext();
  
  React.useEffect(() => {
    if (isFilterVisible) {
      const originalStyles = {
        overflow: document.body.style.overflow,
      };
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = '15px';

      return () => {
        document.body.style.overflow = originalStyles.overflow;
        document.body.style.paddingRight = '0';
      };
    } else {
      return () => {};
    }
  }, [isFilterVisible]);

  const applyFilters = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    const activeFilterKeys = Object.entries(activeFilters)
      .filter(([, value]) => value === true)
      .map(([key]) => key)
      .join(',');
    const request = `&amenities=${activeFilterKeys}`;
    setCurrentAmenities(request);
    setCurrentPage(1);

    fetchData(
      currentLocation.lat,
      currentLocation.lng,
      currentLocation.rad,
      10,
      0,
      currentResources,
      request,
      currentDuration,
      budgetValues,
      sortBy,
    );
    setIsFilterVisible(false);
  };

  const clearFilters = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setActiveFilters({});
  };

  const handleFilterChange = (filterId: string) => {
    setActiveFilters((prevActiveFilters:any) => {
      const updatedFilters = { ...prevActiveFilters };
      updatedFilters[filterId] = !updatedFilters[filterId];

      return updatedFilters;
    });
  };

  const categories = Object.keys(data);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevIsFilterVisible) => !prevIsFilterVisible);
  };

  const handleBackgroundClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    setIsFilterVisible(false);

    // clear chosen filters if we close popup
    const searchParams = new URLSearchParams(location.search);
    const amenitiesFilter = searchParams.get('amenities')?.replace(/^,+/g, '').replace(/,+/g, ',').replace(/,$/g, '').replace(/^undefined,|,undefined$|,undefined,/g, '').replace(/NaN|NaN,|,NaN$|,NaN,/g, '').split(',') || [''];

    setActiveFilters((prev:any) => {
      const updatedFilters:any = {} ;

      for (const key in prev) {
        updatedFilters[key] = false;
      }

      for (let i = 0; i < amenitiesFilter.length; i++) {
        updatedFilters[amenitiesFilter[i]] = true;
      }
      return updatedFilters;
    })
  };

  React.useEffect(() => {
    const count = Object.entries(activeFilters).filter(([key, value]) => /^\d+$/.test(key) && value === true).length;
    setCheckedCount(count);
  }, [activeFilters]);

  return (
    <button className={isFilterVisible || checkedCount > 0 ? styles.container_active : styles.container} onClick={toggleFilterVisibility} type="button">
      <AmenitiesIcon />
      Amenities
      <span style={{ display: checkedCount ? 'block' : 'none' }}>
        {`(${checkedCount})`}
      </span>
      <Chevron style={{ transform: isFilterVisible ? 'rotate(180deg)' : 'none' }} />
      {isFilterVisible && (
        <div className={styles.background} onClick={handleBackgroundClick}>
          <div
            className={styles.container__filters}
            onClick={(e) => {
              e.stopPropagation();
            }}
            style={{ display: isFilterVisible ? 'block' : 'none' }}
          >
            {categories.map((category) => (
              <AllFilterCategory
                key={category}
                category={category}
                filters={typedData[category]}
                onFilterChange={handleFilterChange}
              />
            ))}
          </div>
          <div
            className={styles.container__footer}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <span>{`${checkedCount} selected`}</span>
            <div className={styles.container__footer_buttons}>
              <button onClick={(e) => clearFilters(e)} type="button">Clear all</button>
              <button onClick={(e) => applyFilters(e)} type="button">Apply</button>
            </div>
          </div>
        </div>
      )}
    </button>
  );
};

export default AllFilter;
